import { useCurrentModule } from '../components/ModuleProvider';
export const STUDIO_NEW_UI_SPEC = 'studioNewUi';
export const useIsStudioNewUi = () => {
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  return experiments.isEnabled(STUDIO_NEW_UI_SPEC);
};
//# sourceMappingURL=useIsStudioNewUi.js.map